module.exports = __webpack_public_path__ + "res/ic_filter.e98ca4d55cfb566971aa7a1039695c57.png";